import { flattenChildren } from '../flattenChildren/flattenChildren.es.js';
import { isComponentType } from '../isComponentType/isComponentType.es.js';

var filterChildrenByType = function filterChildrenByType(children, type) {
  return flattenChildren(children).filter(function (item) {
    return Array.isArray(type) ? type.some(function (component) {
      return component === item.type;
    }) : isComponentType(item, type);
  });
};

export { filterChildrenByType };